// Currency conversion utilities
export const EXCHANGE_RATE = 0.00065; // NGN to USD

export const convertPrice = (amount, currency = 'NGN') => {
  if (currency === 'USD') {
    return `$${(amount * EXCHANGE_RATE).toFixed(0)}`;
  }
  return `₦${amount.toLocaleString()}`;
};

// Scroll utility
export const scrollToSection = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

// Format date utility
export const formatDate = (date) => {
  return new Intl.DateTimeFormat('en-NG', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(new Date(date));
};

// Validation utilities
export const validateEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const validatePhone = (phone) => {
  return /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/.test(phone);
};

// API helper (prepare for backend integration)
export const apiClient = async (endpoint, options = {}) => {
  const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:8080';

  const isFormData = options.body instanceof FormData;
  const headers = { ...options.headers };

  if (!isFormData) {
    headers['Content-Type'] = headers['Content-Type'] || 'application/json';
  }

  const config = {
    ...options,
    headers,
  };

  if (options.body && typeof options.body === 'object' && !isFormData) {
    config.body = JSON.stringify(options.body);
  }

  try {
    const response = await fetch(`${baseUrl}${endpoint}`, config);

    if (!response.ok) {
      throw new Error(`API Error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('API Request Failed:', error);
    throw error;
  }
};

// Payment integration helpers
export const initiatePayment = async (paymentData) => {
  // TODO: Integrate with Flutterwave or payment gateway
  return apiClient('/api/payments/initiate', {
    method: 'POST',
    body: paymentData,
  });
};

export const verifyPayment = async (transactionId) => {
  return apiClient(`/api/payments/verify/${transactionId}`);
};

// Booking/appointment helpers
export const createBooking = async (bookingData) => {
  return apiClient('/api/bookings', {
    method: 'POST',
    body: bookingData,
  });
};

export const uploadCV = async (file, userId) => {
  const formData = new FormData();
  formData.append('cv', file);
  formData.append('userId', userId);

  return apiClient('/api/upload/cv', {
    method: 'POST',
    body: formData,
    headers: {}, // Let browser set content-type for FormData
  });
};
